function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e(require("vue")) : "function" == typeof define && define.amd ? define(["vue"], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.VueImagesLoaded = e(require("vue")) : t.VueImagesLoaded = e(t.Vue);
}(this, function (t) {
  return function (t) {
    function e(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        exports: {},
        id: r,
        loaded: !1
      };
      return t[r].call(o.exports, o, o.exports, e), o.loaded = !0, o.exports;
    }

    var n = {};
    return e.m = t, e.c = n, e.p = "/", e(0);
  }([function (t, e, n) {
    var r, o, i;
    !function (s, u) {
      o = [t, e, n(13), n(14), n(43), n(44)], r = u, i = "function" == typeof r ? r.apply(e, o) : r, !(void 0 !== i && (t.exports = i));
    }(this, function (t, e, n, r, o, i) {
      "use strict";

      function s(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }

      function u(t, e) {
        var n = t.length;
        if (n != e.length) return !1;

        for (var r = 0; r < n; r++) {
          var o = t[r],
              i = e[r];
          if (o.img !== i.img || o.src !== i.src) return !1;
        }

        return !0;
      }

      function c(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
        if ("function" != typeof t) throw "imageLoaded directive error: objet " + t + " should be a function " + e;
      }

      function f(t, e) {
        var n = e.value,
            r = e.arg,
            o = e.modifiers;
        if (!r) return c(n), void t.on("always", function (t) {
          return setTimeout(function () {
            return n(t);
          });
        });

        var i = !!o && !!(0, h.default)(o).length,
            s = i ? o : n,
            u = i ? function (t) {
          return n;
        } : function (t) {
          return n[t];
        },
            f = function f() {
          var e = u(a);
          c(e, i ? "" : "property " + a + " of " + n), t[r](a, function (t, n) {
            return setTimeout(function () {
              return e(t, n);
            });
          });
        };

        for (var a in s) {
          f();
        }
      }

      function a(t, e) {
        var n = (0, d.default)(t),
            r = n.images.map(function (t) {
          return {
            img: t.img,
            src: t.img.src
          };
        }),
            o = t.__imagesLoaded__.context;
        u(o, r) || (f(n, e), (0, p.default)(t.__imagesLoaded__, {
          context: r,
          imageLoaded: n
        }));
      }

      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var p = s(n),
          h = s(r),
          d = s(o),
          l = s(i);
      e.default = {
        bind: function bind(t) {
          t.__imagesLoaded__ = {
            context: []
          };
        },
        inserted: function inserted(t, e) {
          a(t, e);
        },
        componentUpdated: function componentUpdated(t, e) {
          l.default.nextTick(function () {
            a(t, e);
          });
        },
        unbind: function unbind(t, e) {
          t.__imagesLoaded__ = null;
        }
      }, t.exports = e.default;
    });
  }, function (t, e) {
    var n = t.exports = {
      version: "2.4.0"
    };
    "number" == typeof __e && (__e = n);
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, e, n) {
    t.exports = !n(2)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e) {
    var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = n);
  }, function (t, e) {
    t.exports = function (t) {
      return "object" == _typeof(t) ? null !== t : "function" == typeof t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);
      return t;
    };
  }, function (t, e, n) {
    var r = n(4),
        o = n(1),
        i = n(21),
        s = n(25),
        u = "prototype",
        c = function c(t, e, n) {
      var f,
          a,
          p,
          h = t & c.F,
          d = t & c.G,
          l = t & c.S,
          v = t & c.P,
          m = t & c.B,
          g = t & c.W,
          y = d ? o : o[e] || (o[e] = {}),
          x = y[u],
          b = d ? r : l ? r[e] : (r[e] || {})[u];
      d && (n = e);

      for (f in n) {
        a = !h && b && void 0 !== b[f], a && f in y || (p = a ? b[f] : n[f], y[f] = d && "function" != typeof b[f] ? n[f] : m && a ? i(p, r) : g && b[f] == p ? function (t) {
          var e = function e(_e, n, r) {
            if (this instanceof t) {
              switch (arguments.length) {
                case 0:
                  return new t();

                case 1:
                  return new t(_e);

                case 2:
                  return new t(_e, n);
              }

              return new t(_e, n, r);
            }

            return t.apply(this, arguments);
          };

          return e[u] = t[u], e;
        }(p) : v && "function" == typeof p ? i(Function.call, p) : p, v && ((y.virtual || (y.virtual = {}))[f] = p, t & c.R && x && !x[f] && s(x, f, p)));
      }
    };

    c.F = 1, c.G = 2, c.S = 4, c.P = 8, c.B = 16, c.W = 32, c.U = 64, c.R = 128, t.exports = c;
  }, function (t, e, n) {
    var r = n(20);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == r(t) ? t.split("") : Object(t);
    };
  }, function (t, e, n) {
    var r = n(30),
        o = n(23);

    t.exports = Object.keys || function (t) {
      return r(t, o);
    };
  }, function (t, e) {
    var n = Math.ceil,
        r = Math.floor;

    t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
    };
  }, function (t, e, n) {
    var r = n(8),
        o = n(6);

    t.exports = function (t) {
      return r(o(t));
    };
  }, function (t, e, n) {
    var r = n(6);

    t.exports = function (t) {
      return Object(r(t));
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(15),
      __esModule: !0
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(16),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(40), t.exports = n(1).Object.assign;
  }, function (t, e, n) {
    n(41), t.exports = n(1).Object.keys;
  }, function (t, e) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");
      return t;
    };
  }, function (t, e, n) {
    var r = n(5);

    t.exports = function (t) {
      if (!r(t)) throw TypeError(t + " is not an object!");
      return t;
    };
  }, function (t, e, n) {
    var r = n(11),
        o = n(37),
        i = n(36);

    t.exports = function (t) {
      return function (e, n, s) {
        var u,
            c = r(e),
            f = o(c.length),
            a = i(s, f);

        if (t && n != n) {
          for (; f > a;) {
            if (u = c[a++], u != u) return !0;
          }
        } else for (; f > a; a++) {
          if ((t || a in c) && c[a] === n) return t || a || 0;
        }

        return !t && -1;
      };
    };
  }, function (t, e) {
    var n = {}.toString;

    t.exports = function (t) {
      return n.call(t).slice(8, -1);
    };
  }, function (t, e, n) {
    var r = n(17);

    t.exports = function (t, e, n) {
      if (r(t), void 0 === e) return t;

      switch (n) {
        case 1:
          return function (n) {
            return t.call(e, n);
          };

        case 2:
          return function (n, r) {
            return t.call(e, n, r);
          };

        case 3:
          return function (n, r, o) {
            return t.call(e, n, r, o);
          };
      }

      return function () {
        return t.apply(e, arguments);
      };
    };
  }, function (t, e, n) {
    var r = n(5),
        o = n(4).document,
        i = r(o) && r(o.createElement);

    t.exports = function (t) {
      return i ? o.createElement(t) : {};
    };
  }, function (t, e) {
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (t, e) {
    var n = {}.hasOwnProperty;

    t.exports = function (t, e) {
      return n.call(t, e);
    };
  }, function (t, e, n) {
    var r = n(28),
        o = n(33);
    t.exports = n(3) ? function (t, e, n) {
      return r.f(t, e, o(1, n));
    } : function (t, e, n) {
      return t[e] = n, t;
    };
  }, function (t, e, n) {
    t.exports = !n(3) && !n(2)(function () {
      return 7 != Object.defineProperty(n(22)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(9),
        o = n(29),
        i = n(31),
        s = n(12),
        u = n(8),
        c = Object.assign;
    t.exports = !c || n(2)(function () {
      var t = {},
          e = {},
          n = Symbol(),
          r = "abcdefghijklmnopqrst";
      return t[n] = 7, r.split("").forEach(function (t) {
        e[t] = t;
      }), 7 != c({}, t)[n] || Object.keys(c({}, e)).join("") != r;
    }) ? function (t, e) {
      for (var n = s(t), c = arguments.length, f = 1, a = o.f, p = i.f; c > f;) {
        for (var h, d = u(arguments[f++]), l = a ? r(d).concat(a(d)) : r(d), v = l.length, m = 0; v > m;) {
          p.call(d, h = l[m++]) && (n[h] = d[h]);
        }
      }

      return n;
    } : c;
  }, function (t, e, n) {
    var r = n(18),
        o = n(26),
        i = n(38),
        s = Object.defineProperty;
    e.f = n(3) ? Object.defineProperty : function (t, e, n) {
      if (r(t), e = i(e, !0), r(n), o) try {
        return s(t, e, n);
      } catch (t) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
      return "value" in n && (t[e] = n.value), t;
    };
  }, function (t, e) {
    e.f = Object.getOwnPropertySymbols;
  }, function (t, e, n) {
    var r = n(24),
        o = n(11),
        i = n(19)(!1),
        s = n(34)("IE_PROTO");

    t.exports = function (t, e) {
      var n,
          u = o(t),
          c = 0,
          f = [];

      for (n in u) {
        n != s && r(u, n) && f.push(n);
      }

      for (; e.length > c;) {
        r(u, n = e[c++]) && (~i(f, n) || f.push(n));
      }

      return f;
    };
  }, function (t, e) {
    e.f = {}.propertyIsEnumerable;
  }, function (t, e, n) {
    var r = n(7),
        o = n(1),
        i = n(2);

    t.exports = function (t, e) {
      var n = (o.Object || {})[t] || Object[t],
          s = {};
      s[t] = e(n), r(r.S + r.F * i(function () {
        n(1);
      }), "Object", s);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      };
    };
  }, function (t, e, n) {
    var r = n(35)("keys"),
        o = n(39);

    t.exports = function (t) {
      return r[t] || (r[t] = o(t));
    };
  }, function (t, e, n) {
    var r = n(4),
        o = "__core-js_shared__",
        i = r[o] || (r[o] = {});

    t.exports = function (t) {
      return i[t] || (i[t] = {});
    };
  }, function (t, e, n) {
    var r = n(10),
        o = Math.max,
        i = Math.min;

    t.exports = function (t, e) {
      return t = r(t), t < 0 ? o(t + e, 0) : i(t, e);
    };
  }, function (t, e, n) {
    var r = n(10),
        o = Math.min;

    t.exports = function (t) {
      return t > 0 ? o(r(t), 9007199254740991) : 0;
    };
  }, function (t, e, n) {
    var r = n(5);

    t.exports = function (t, e) {
      if (!r(t)) return t;
      var n, o;
      if (e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
      if ("function" == typeof (n = t.valueOf) && !r(o = n.call(t))) return o;
      if (!e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, e) {
    var n = 0,
        r = Math.random();

    t.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
    };
  }, function (t, e, n) {
    var r = n(7);
    r(r.S + r.F, "Object", {
      assign: n(27)
    });
  }, function (t, e, n) {
    var r = n(12),
        o = n(9);
    n(32)("keys", function () {
      return function (t) {
        return o(r(t));
      };
    });
  }, function (t, e, n) {
    var r, o;
    !function (i, s) {
      r = s, o = "function" == typeof r ? r.call(e, n, e, t) : r, !(void 0 !== o && (t.exports = o));
    }("undefined" != typeof window ? window : this, function () {
      "use strict";

      function t() {}

      var e = t.prototype;
      return e.on = function (t, e) {
        if (t && e) {
          var n = this._events = this._events || {},
              r = n[t] = n[t] || [];
          return r.indexOf(e) == -1 && r.push(e), this;
        }
      }, e.once = function (t, e) {
        if (t && e) {
          this.on(t, e);
          var n = this._onceEvents = this._onceEvents || {},
              r = n[t] = n[t] || {};
          return r[e] = !0, this;
        }
      }, e.off = function (t, e) {
        var n = this._events && this._events[t];

        if (n && n.length) {
          var r = n.indexOf(e);
          return r != -1 && n.splice(r, 1), this;
        }
      }, e.emitEvent = function (t, e) {
        var n = this._events && this._events[t];

        if (n && n.length) {
          var r = 0,
              o = n[r];
          e = e || [];

          for (var i = this._onceEvents && this._onceEvents[t]; o;) {
            var s = i && i[o];
            s && (this.off(t, o), delete i[o]), o.apply(this, e), r += s ? 0 : 1, o = n[r];
          }

          return this;
        }
      }, t;
    });
  }, function (t, e, n) {
    var r, o;
    /*!
    * imagesLoaded v4.1.1
    * JavaScript is all like "You images are done yet or what?"
    * MIT License
    */

    !function (i, s) {
      "use strict";

      r = [n(42)], o = function (t) {
        return s(i, t);
      }.apply(e, r), !(void 0 !== o && (t.exports = o));
    }(window, function (t, e) {
      "use strict";

      function n(t, e) {
        for (var n in e) {
          t[n] = e[n];
        }

        return t;
      }

      function r(t) {
        var e = [];
        if (Array.isArray(t)) e = t;else if ("number" == typeof t.length) for (var n = 0; n < t.length; n++) {
          e.push(t[n]);
        } else e.push(t);
        return e;
      }

      function o(t, e, i) {
        return this instanceof o ? ("string" == typeof t && (t = document.querySelectorAll(t)), this.elements = r(t), this.options = n({}, this.options), "function" == typeof e ? i = e : n(this.options, e), i && this.on("always", i), this.getImages(), u && (this.jqDeferred = new u.Deferred()), void setTimeout(function () {
          this.check();
        }.bind(this))) : new o(t, e, i);
      }

      function i(t) {
        this.img = t;
      }

      function s(t, e) {
        this.url = t, this.element = e, this.img = new Image();
      }

      var u = t.jQuery,
          c = t.console;
      o.prototype = Object.create(e.prototype), o.prototype.options = {}, o.prototype.getImages = function () {
        this.images = [], this.elements.forEach(this.addElementImages, this);
      }, o.prototype.addElementImages = function (t) {
        "IMG" == t.nodeName && this.addImage(t), this.options.background === !0 && this.addElementBackgroundImages(t);
        var e = t.nodeType;

        if (e && f[e]) {
          for (var n = t.querySelectorAll("img"), r = 0; r < n.length; r++) {
            var o = n[r];
            this.addImage(o);
          }

          if ("string" == typeof this.options.background) {
            var i = t.querySelectorAll(this.options.background);

            for (r = 0; r < i.length; r++) {
              var s = i[r];
              this.addElementBackgroundImages(s);
            }
          }
        }
      };
      var f = {
        1: !0,
        9: !0,
        11: !0
      };
      return o.prototype.addElementBackgroundImages = function (t) {
        var e = getComputedStyle(t);
        if (e) for (var n = /url\((['"])?(.*?)\1\)/gi, r = n.exec(e.backgroundImage); null !== r;) {
          var o = r && r[2];
          o && this.addBackground(o, t), r = n.exec(e.backgroundImage);
        }
      }, o.prototype.addImage = function (t) {
        var e = new i(t);
        this.images.push(e);
      }, o.prototype.addBackground = function (t, e) {
        var n = new s(t, e);
        this.images.push(n);
      }, o.prototype.check = function () {
        function t(t, n, r) {
          setTimeout(function () {
            e.progress(t, n, r);
          });
        }

        var e = this;
        return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? void this.images.forEach(function (e) {
          e.once("progress", t), e.check();
        }) : void this.complete();
      }, o.prototype.progress = function (t, e, n) {
        this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded, this.emitEvent("progress", [this, t, e]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t), this.progressedCount == this.images.length && this.complete(), this.options.debug && c && c.log("progress: " + n, t, e);
      }, o.prototype.complete = function () {
        var t = this.hasAnyBroken ? "fail" : "done";

        if (this.isComplete = !0, this.emitEvent(t, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
          var e = this.hasAnyBroken ? "reject" : "resolve";
          this.jqDeferred[e](this);
        }
      }, i.prototype = Object.create(e.prototype), i.prototype.check = function () {
        var t = this.getIsImageComplete();
        return t ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image(), this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), void (this.proxyImage.src = this.img.src));
      }, i.prototype.getIsImageComplete = function () {
        return this.img.complete && void 0 !== this.img.naturalWidth;
      }, i.prototype.confirm = function (t, e) {
        this.isLoaded = t, this.emitEvent("progress", [this, this.img, e]);
      }, i.prototype.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }, i.prototype.onload = function () {
        this.confirm(!0, "onload"), this.unbindEvents();
      }, i.prototype.onerror = function () {
        this.confirm(!1, "onerror"), this.unbindEvents();
      }, i.prototype.unbindEvents = function () {
        this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
      }, s.prototype = Object.create(i.prototype), s.prototype.check = function () {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url;
        var t = this.getIsImageComplete();
        t && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
      }, s.prototype.unbindEvents = function () {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
      }, s.prototype.confirm = function (t, e) {
        this.isLoaded = t, this.emitEvent("progress", [this, this.element, e]);
      }, o.makeJQueryPlugin = function (e) {
        e = e || t.jQuery, e && (u = e, u.fn.imagesLoaded = function (t, e) {
          var n = new o(this, t, e);
          return n.jqDeferred.promise(u(this));
        });
      }, o.makeJQueryPlugin(), o;
    });
  }, function (e, n) {
    e.exports = t;
  }]);
});